import { handleError } from "../utils/errorHandler";
import SnackbarUtils from "../utils/snackbarUtils";
import { showUpdateDialog } from "@accessinformatica/service-worker";

export const reduxErrorMiddleware = (store) => (next) => (action) => {
  if (action.type.includes("persist")) return next(action);
  // Manejo cambio de versión
  if (action.payload?.request?.status === 426) {
    store.dispatch(showUpdateDialog());
    return;
  }
  const errors = handleError(action);
  errors.forEach((error) => {
    SnackbarUtils.error(error.message);
  });
  return next(action);
};
